import { Route, Routes } from "react-router-dom";
import Login from "./Components/Login";

import Signup from './Components/Signup.js';
import Chat from "./Components/Chat.js";
import Home from "./Components/Home.js"
import AddProduct from "./Components/AddProduct.js";
import Shop from "./Components/Shop.js";
import View from "./Components/View.js";
import Cart from "./Components/Cart.js";
import Orders from "./Components/Orders.js";
import Profile from "./Components/Profile.js";
import SearchShop from "./Components/SearchShop.js";
const AppRoutes = () =>{
     return(
        <>
        <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/:view" element={<View/>} />
            <Route path="/signup" element={<Signup/>}/>
            <Route path="/login" element={<Login/>} />
            <Route path="/chat" element={<Chat/>}/>
            <Route path="/add" element={<AddProduct/>}/>
            <Route path="/shop" element={<Shop/>} />
            <Route path="/shop/:view" element={<View/>} />
            
            <Route path="/cart" element={<Cart/>} />
            <Route path="/order" element={<Orders/>} />
            <Route path="/profile" element={<Profile/>} />
            <Route path="/search" element={<SearchShop/>} />
            <Route path="/search/:view" element={<View/>} />
        </Routes>
        </>
     );
}

export default AppRoutes;